import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MotifAvatarModule } from '@ey-xd/ng-motif';
import { EytcAuthService } from '@services/authentication/eytc-auth.service';

@Component({
  selector: 'app-user-info',
  standalone: true,
  imports: [MotifAvatarModule],
  templateUrl: './user-info.component.html',
  styleUrl: './user-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
  #authService = inject(EytcAuthService);

  public get fullName() {
    return this.#authService.userProfile()?.fullName ?? '';
  }

  public get userEmail() {
    return this.#authService.userProfile()?.email ?? '';
  }
}
